import React from 'react';
import { Link } from 'react-router-dom';
import './KitDetails.css';

const KitDetails = () => {
  const kitItems = [
    {
      title: '3D Printed Chassis',
      description: 'Durable foundation for your robot'
    },
    {
      title: '2× Servo Motors',
      description: 'Precise control for robot movement'
    },
    {
      title: '2× 3D Printed Servo Mounts',
      description: 'Clicks on and holds servos in place'
    },
    {
      title: '2× 3D Printed Wheels',
      description: 'Smooth motion for various surfaces'
    },
    {
      title: 'PCB Board',
      description: 'Custom circuit board'
    },
    {
      title: 'Micro:Bit',
      description: 'Microcontroller'
    },
    {
      title: 'Battery Holder',
      description: 'Power your robot for extended sessions'
    },
    {
      title: 'Training Wheel',
      description: 'Provides stability for smooth navigation'
    }
  ];

  return (
    <section id="kit" className="section kit-section">
      <div className="container">
        <div className="section-title">
          <h2>What's In The Kit</h2>
          <p>Everything you need to build your robot</p>
        </div>

        <div className="kit-content">
          <div className="kit-image">
            <img src="/placeholder-kit.jpg" alt="Nozomi Robotics Kit Contents" />
          </div>

          <div className="kit-details">
            <h3>Kit Components</h3>

            <div className="kit-items">
              {kitItems.map((item, index) => (
                <div className="kit-item" key={index}>
                  <span className="kit-item-icon">✓</span>
                  <div>
                    <strong>{item.title}</strong>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/specifications" className="cta-button">View Full Specifications</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KitDetails;